<template>
  <div class="card skel-card">
    <div class="skel" style="width:72px;height:72px;border-radius:50%" />
    <div class="sk-lines">
      <div class="skel" style="height:18px;width:45%" />
      <div class="skel" style="height:13px;width:30%" />
      <div class="skel" style="height:13px;width:60%" />
    </div>
    <div class="sk-lines" style="align-items:flex-end">
      <div class="skel" style="height:24px;width:90px" />
      <div class="skel" style="height:38px;width:150px" />
      <div class="skel" style="height:36px;width:150px" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DoctorsListCardSkeleton"
};
</script>
